import React, {useEffect} from 'react';
import {Routes, Route, useNavigate} from 'react-router-dom';
import AuthPage from "@/pages/auth/AuthPage";
import PrivacyPage from "@/pages/privacy/PrivacyPage";
import AdminPanel from "@/pages/adminPanel/AdminPanel";
import CompleteReg from "@/pages/auth/registration/CompleteReg"
import { AdminPrivateRoute } from './AdminPrivateRoute';
import LoginPage from "@/pages/adminPanel/Components/LoginPage";
import CreateGamePage from '@/pages/adminPanel/Components/gamesCards/CreateGamePage.jsx';
import EditGamePage from '@/pages/adminPanel/Components/gamesCards/EditGamePage.jsx';
import CreateEmployeePage from '@/pages/adminPanel/Components/employees/CreateEmployeePage.jsx';
import EditEmployeePage from '@/pages/adminPanel/Components/employees/EditEmployeePage';
import EditPlayersPage from "@/pages/adminPanel/Components/Schedule/EditPlayersPage";
import ScheduleForm from "@/pages/adminPanel/Components/Schedule/ScheduleForm.jsx";
import ScrollToTop from "./ScrollToTop";
import {EmployeeProvider} from "@/pages/adminPanel/context/EmployeeProvider.jsx";
import NotFound from "@/pages/404/404";
import ProfilePage from "@/pages/profile/Profile.jsx";
import EditProfilePage from "@/pages/profile/components/EditProfilePage";
import useAxiosInterceptor from '@/shared/api/useAxiosInterceptor';
import ErrorPage from "@/pages/ErrorPage/ErrorPage";
import {setupAdminAxiosInterceptor} from "@/shared/api/useAdminAxiosInterceptor.js";
import Registration from "@/pages/auth/registration/Registration";
import HomePage from "@/pages/home/HomePage";
import CatalogPage from "@/pages/Catalog/CatalogPage.jsx";
import AboutMastersPage from "@/pages/AboutMasters/AboutMastersPage.jsx";
import BuySuccessPage from "@/pages/BuySuccess/BuySuccessPage.jsx";
import EditPromoPage from "@/pages/adminPanel/Components/promo/EditPromoPage.jsx";
import CreatePromoPage from "@/pages/adminPanel/Components/promo/CreatePromoPage.jsx";
import {AppProviders} from "@/app/providers/AppProviders.jsx";

export const AppRouter = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setupAdminAxiosInterceptor(navigate);
    }, [navigate]);
    useAxiosInterceptor();

    return (
        <>
            <ScrollToTop/>
            <AppProviders>
                <Routes>
                    {/* Public */}
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/privacy" element={<PrivacyPage/>}/>
                    <Route path="/profile" element={<ProfilePage/>}/>
                    <Route path="/profile/edit" element={<EditProfilePage/>}/>
                    <Route path={'/catalog'} element={<CatalogPage/>}/>
                    <Route path={'/masters'} element={<AboutMastersPage />} />
                    <Route path={'/payment'} element={<BuySuccessPage/>}/>

                    {/* Auth */}
                    <Route path="/auth" element={<AuthPage/>}/>
                    <Route path="/registration" element={<Registration/>} />
                    <Route path="/auth/complete-reg" element={<CompleteReg/>}/>
                    <Route path="/auth/complete-reg/oauth-success" element={<CompleteReg/>}/>

                    {/* Admin Auth */}
                    <Route path="/admin/auth" element={<LoginPage/>}/>

                    {/* Admin Panel */}
                    <Route path="/admin" element={<AdminPrivateRoute><AdminPanel/></AdminPrivateRoute>}/>

                    {/* Admin Games */}
                    <Route path="/admin/games/create"
                           element={<EmployeeProvider><AdminPrivateRoute><CreateGamePage/></AdminPrivateRoute>
                           </EmployeeProvider>}/>
                    <Route path="/admin/games/edit/:id" element={
                        <EmployeeProvider><AdminPrivateRoute><EditGamePage/></AdminPrivateRoute></EmployeeProvider>}/>

                    {/* Admin Employees */}
                    <Route path="/admin/employees/create" element={
                        <EmployeeProvider><AdminPrivateRoute><CreateEmployeePage/></AdminPrivateRoute></EmployeeProvider>}/>
                    <Route path="/admin/employees/edit/:id" element={
                        <EmployeeProvider><AdminPrivateRoute><EditEmployeePage/></AdminPrivateRoute></EmployeeProvider>}/>

                    {/* Admin Schedule */}
                    <Route path="/admin/schedule/create" element={<EmployeeProvider><AdminPrivateRoute>
                        <main className="min-vh-100 bg-light"><ScheduleForm/></main>
                    </AdminPrivateRoute></EmployeeProvider>}/>
                    <Route path="/admin/schedule/edit/:id" element={<EmployeeProvider><AdminPrivateRoute>
                        <main className="min-vh-100 bg-light"><ScheduleForm/></main>
                    </AdminPrivateRoute></EmployeeProvider>}/>
                    <Route path="/admin/schedule/:id/players" element={
                        <EmployeeProvider><AdminPrivateRoute><EditPlayersPage/></AdminPrivateRoute></EmployeeProvider>}/>

                    {/* Admin promo */}
                    <Route path="/admin/promo/create" element={
                        <EmployeeProvider><AdminPrivateRoute><CreatePromoPage/></AdminPrivateRoute></EmployeeProvider>}/>

                    <Route path="/admin/promo/edit/:id" element={
                        <EmployeeProvider><AdminPrivateRoute><EditPromoPage/></AdminPrivateRoute></EmployeeProvider>}/>

                    <Route path="/error" element={<ErrorPage />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </AppProviders>
        </>
    );
}
